import {
  Paper,
  Group,
  Divider,
  Skeleton,
  SimpleGrid,
} from "@mantine/core";
import useIsDesktop from "../../../hooks/useIsDesktop";

export default function MerchantProfileSkeleton() {
  const isDesktop = useIsDesktop();
  const logoSize = isDesktop ? 128 : 80;

  return (
    <Paper shadow="xs" radius="md" p={{ base: "sm", sm: "xl" }} className="bg-white">
      <Group justify="space-between" align="center" mb="sm" wrap="wrap" gap="sm">
        <div>
          <Skeleton height={isDesktop ? 20 : 16} width={180} radius="sm" />
          <Skeleton height={isDesktop ? 14 : 12} width={140} mt={8} radius="sm" />
        </div>

        <Skeleton height={isDesktop ? 36 : 30} width={isDesktop ? 140 : 110} radius="xl" />
      </Group>

      <Divider my="lg" />

      <div className="mb-8">
        <div className="flex items-center justify-between flex-wrap gap-2 mb-2">
          <Skeleton height={isDesktop ? 18 : 14} width={120} radius="sm" />
          <Skeleton height={isDesktop ? 34 : 28} width={isDesktop ? 120 : 100} radius="xl" />
        </div>

        <Skeleton height={logoSize} width={logoSize} radius="100%" />
      </div>

      <Divider my="lg" />

      <div className="space-y-8">
        <div>
          <Skeleton height={isDesktop ? 18 : 14} width={180} radius="sm" mb={16} />

          <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md" mb="md">
            <Skeleton height={50} radius="xl" />
            <Skeleton height={50} radius="xl" />
          </SimpleGrid>

          <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md" mb="md">
            <Skeleton height={50} radius="xl" />
            <Skeleton height={50} radius="xl" />
          </SimpleGrid>
        </div>

        <Divider my="lg" />

        <div>
          <Skeleton height={isDesktop ? 18 : 14} width={200} radius="sm" mb={16} />

          {[1, 2].map((i) => (
            <div key={i} className="mb-3 p-3 rounded-lg bg-gray-50">
              <Skeleton height={14} width={150} radius="sm" />
              <Skeleton height={12} width={100} mt={6} radius="sm" />
              <Skeleton height={10} width={120} mt={6} radius="sm" />
            </div>
          ))}
        </div>
      </div>
    </Paper>
  );
}
